// TODO: get better way to do this, maybe move all constants to a new lib
export const SALFA_RAC_EXT_BUSINESS_UNIT_ID = 33;
export const SALFA_RAC_AEROPUERTO_BUSINESS_UNIT_ID = 188;
export const GAMA_MOBILITY_BUSINESS_UNIT_ID = 133;

export const SHARED_CLIENT_POOL_BUSINESS_UNIT_IDS = [
  SALFA_RAC_EXT_BUSINESS_UNIT_ID,
  SALFA_RAC_AEROPUERTO_BUSINESS_UNIT_ID,
  GAMA_MOBILITY_BUSINESS_UNIT_ID,
];
